var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgAddUser = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "add")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBookPro-2017",
    transform: "translate(-75.000000, -301.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(76.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,15 L0,15 C0,13.6666667 1,12.6666667 3,12 C6,11 6,10 6,9 C6,8 4,8 4,5 C4,2 5,0 8,0",
    id: "Path-4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11.8352467 C10.6825886,11.0652047 10.5,10 10.5,9 C10.5,8 8.5,8 8.5,5 C8.5,2 9.5,1.0658141e-14 12.5,1.0658141e-14",
    id: "Path-4",
    strokeLinejoin: "round",
    transform: "translate(10.250000, 5.917623) scale(-1, 1) translate(-10.250000, -5.917623) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 11.5,
    x2: 14.5,
    y2: 15.5,
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 13.5,
    x2: 12.5,
    y2: 13.5,
    id: "Line-5"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addUser.d24257c4.svg";
export { ForwardRef as ReactComponent };